import { clientBankDocumentsRoute } from './ClientBankDocumentsPage/route';
import { clientUploadedByClientDocumentsRoute } from './ClientUploadedByClientDocumentsPage/route';
import { clientDocumentsRoute } from './route';

export const clientDocumentsRoutes = clientDocumentsRoute.addChildren([
	clientBankDocumentsRoute,
	clientUploadedByClientDocumentsRoute,
]);
